var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-button",
        { attrs: { variant: "primary" }, on: { click: _vm.openModal } },
        [_vm._v("\n        Vermerk hinzufügen\n    ")]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { "hide-footer": "", size: "xl", title: "Vermerk hinzufügen" },
          on: {
            hide: function ($event) {
              return _vm.reset()
            },
          },
          model: {
            value: _vm.isModalOpen,
            callback: function ($$v) {
              _vm.isModalOpen = $$v
            },
            expression: "isModalOpen",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "record-note-create-modal loading-content-container",
            },
            [
              _vm.isLoading
                ? _c(
                    "div",
                    {
                      staticClass:
                        "loading-overlay d-flex justify-content-center pt-5",
                    },
                    [_c("csp-loading-indicator")],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.isLoading
                ? _c(
                    "csp-desktop-info-card",
                    {
                      attrs: {
                        cols: 12,
                        "form-context": _vm.formContext,
                        icon: "inticon-users",
                        title: "Kunde",
                      },
                      on: { "cancel-form": _vm.reset, save: _vm.saveNewNote },
                    },
                    [
                      _c("h2", [_vm._v("Grunddaten")]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("csp-desktop-info-card-element", {
                            staticClass: "col-3",
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "Thema",
                              "options-loader": _vm.loadNoteCodeCategoryOptions,
                              property: "noteCodeCategory",
                              required: true,
                              type: "autocomplete",
                            },
                          }),
                          _vm._v(" "),
                          _c("csp-desktop-info-card-element", {
                            staticClass: "col-9",
                            attrs: {
                              dependencies: ["noteCodeCategory"],
                              "form-context": _vm.formContext,
                              label: "Vorgefertigte Vermerke",
                              "options-loader": _vm.loadNoteCodeOptions,
                              property: "noteCode",
                              required: true,
                              type: "autocomplete",
                            },
                            on: { change: _vm.handleNoteCodeSelected },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("csp-desktop-info-card-element", {
                            staticClass: "col-9",
                            attrs: {
                              "form-context": _vm.formContext,
                              label:
                                "Fügen Sie hier einen eigenen Vermerk/Freitext ein",
                              property: "note",
                              required:
                                !_vm.formContext.permissions.canChangeNoteCode,
                              type: "autogrowtextarea",
                            },
                          }),
                          _vm._v(" "),
                          _c("csp-desktop-info-card-element", {
                            staticClass: "col-3",
                            attrs: {
                              "form-context": _vm.formContext,
                              "is-loading-from-parent":
                                _vm.isLoadingHideSettings > 0,
                              label: "Nicht anzeigen für",
                              "mandatory-hide-for-group":
                                _vm.mandatoryHideForGroup,
                              options: _vm.hideForGroupOptionsAvailable,
                              property: "hide",
                              "record-id": _vm.recordId,
                              type: "hideForGroup",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("csp-desktop-info-card-element", {
                            staticClass: "col-3",
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "Vermerk erstellen als",
                              options:
                                _vm.formContext.complexFields.creatorId
                                  ?.options,
                              property: "creatorId",
                              type: "autocomplete",
                            },
                          }),
                          _vm._v(" "),
                          _c("csp-desktop-info-card-element", {
                            staticClass: "col-3 align-content-end",
                            attrs: {
                              "form-context": _vm.formContext,
                              "hide-label": true,
                              label: "PRIO",
                              property: "hasPriority",
                              type: "checkbox",
                            },
                          }),
                          _vm._v(" "),
                          !_vm.isAppointmentNoteCode
                            ? _c("csp-desktop-info-card-element", {
                                staticClass: "col-3 align-content-end",
                                attrs: {
                                  "form-context": _vm.formContext,
                                  "hide-label": true,
                                  label: "Frist setzen",
                                  property: "hasDeadline",
                                  type: "checkbox",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isAppointmentNoteCode
                            ? _c("csp-desktop-info-card-element", {
                                staticClass: "col-3 align-content-end",
                                attrs: {
                                  "form-context": _vm.formContext,
                                  "hide-label": true,
                                  label: "Frist ist extern",
                                  property: "externalDeadline",
                                  type: "checkbox",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isAppointmentNoteCode
                            ? _c("csp-desktop-info-card-element", {
                                staticClass: "col-3",
                                attrs: {
                                  "form-context": _vm.formContext,
                                  label: _vm.formContext.form.getProperty(
                                    "hasDeadline"
                                  )
                                    ? "Datum Frist"
                                    : "Datum Wiedervorlage",
                                  "max-date": null,
                                  "min-date": _vm.dateNowAsString(),
                                  property: "dateReminder",
                                  type: "datepicker",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isAppointmentNoteCode
                            ? _c("csp-desktop-info-card-element", {
                                staticClass: "col-3",
                                attrs: {
                                  "form-context": _vm.formContext,
                                  label: "Termin",
                                  "max-date": null,
                                  "min-date": _vm.dateNowAsString(),
                                  property: "dateAppointment",
                                  required: true,
                                  type: "datepicker",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isAppointmentNoteCode
                            ? _c("csp-desktop-info-card-element", {
                                staticClass: "col-1 align-content-end",
                                attrs: {
                                  "form-context": _vm.formContext,
                                  "hide-label": true,
                                  label: "Terminzeit",
                                  property: "timeAppointment",
                                  required: true,
                                  step: "60",
                                  type: "time",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("b-col", { attrs: { cols: "9" } }),
                          _vm._v(" "),
                          _vm.formContext.form.getProperty("dateReminder")
                            ? _c("csp-desktop-info-card-element", {
                                staticClass: "col-3 reminder-color-code",
                                attrs: {
                                  buttons: true,
                                  "form-context": _vm.formContext,
                                  label: "Wiedervorlage Farbmarkierung",
                                  property: "reminderColorCode",
                                  type: "radio",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c("csp-desktop-info-card-element", {
                            staticClass: "col-6 add-recipient-select",
                            attrs: {
                              "form-context": _vm.formContext,
                              label: "Empfänger hinzufügen",
                              options:
                                _vm.formContext.complexFields.noteRecipients
                                  .options,
                              property: "noteRecipients",
                              "reset-after": true,
                              type: "autocomplete",
                            },
                            on: { change: _vm.selectRecipient },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.selectedRecipients.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass: "note-recipients-container striped",
                            },
                            [
                              _c("h2", { staticClass: "my-3" }, [
                                _vm._v(
                                  "\n                        Gewählte Empfänger\n                    "
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.selectedRecipients,
                                function (selectedRecipient) {
                                  return _c(
                                    "b-row",
                                    {
                                      key: selectedRecipient.id,
                                      class:
                                        _vm.classesForRecipientRow(
                                          selectedRecipient
                                        ),
                                    },
                                    [
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "1" } },
                                        [
                                          _c(
                                            "b-button",
                                            {
                                              attrs: {
                                                disabled:
                                                  !selectedRecipient.canBeDisabled,
                                                variant: "secondary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.unselectRecipient(
                                                    selectedRecipient
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                X\n                            "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("b-col", { attrs: { cols: "3" } }, [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(selectedRecipient.label) +
                                            "\n                        "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("b-col", { attrs: { cols: "3" } }, [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              selectedRecipient.groupName
                                            ) +
                                            "\n                        "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "2" } },
                                        [
                                          _c(
                                            "b-form-checkbox",
                                            {
                                              attrs: {
                                                disabled:
                                                  _vm.inquiryRecipient &&
                                                  _vm.inquiryRecipient.id !==
                                                    selectedRecipient.id,
                                              },
                                              on: {
                                                input:
                                                  _vm.ensureInquiryRecipientNotHidden,
                                              },
                                              model: {
                                                value:
                                                  selectedRecipient.inquiry,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    selectedRecipient,
                                                    "inquiry",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "selectedRecipient.inquiry",
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v("Antwort erforderlich"),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        { attrs: { cols: "3" } },
                                        [
                                          _c(
                                            "b-form-checkbox",
                                            {
                                              attrs: {
                                                disabled:
                                                  selectedRecipient.forceMailNotification,
                                              },
                                              model: {
                                                value:
                                                  selectedRecipient.emailNotification,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    selectedRecipient,
                                                    "emailNotification",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "selectedRecipient.emailNotification",
                                              },
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "E-Mail Benachrichtigung"
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.formContext.data.firmRemarks
                        ? _c("div", [
                            _c("hr"),
                            _vm._v(" "),
                            _c("h2", [_vm._v("Hinweise")]),
                            _vm._v(" "),
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.formContext.data.firmRemarks
                                ),
                              },
                            }),
                          ])
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }